/*global Ractive, RedmarineUXTemplates, BaseComponent, RactiveEventsKeys */
// Add it to Global Ractive object
Ractive.components['ux-autocomplete'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxautocompleteUxautocomplete,

	data: {
		delay: 500,
		minChars: 3,
		selectedIndex: -1,
		queryParameter: 'query',
		responseKeyPath: null,
		responseTitleField: 'title',
		responseType: "json",
		allowScrolling: true,
		limit: 0,
		url: '#',
		component: 'ux-autocomplete',
		multipleSources: false,
		closeAutoSuggestion: true
	},

	events: {
		uparrow: RactiveEventsKeys.uparrow,
		downarrow: RactiveEventsKeys.downarrow,
		rightarrow: RactiveEventsKeys.rightarrow,
		enter: RactiveEventsKeys.enter,
		space: RactiveEventsKeys.space
	},

	computed: {
		typeahead: function() {
			var suggestions = this.get('suggestions'),
				userInput   = this.get('userInput'),
				typeahead   = '',
				titleField  = this.get('responseTitleField'),
				inputRegex  = new RegExp('^' + userInput, 'i');
			if (suggestions) {
				typeahead = userInput + _.result(_.find(suggestions, function(item) {
					if (item[titleField].match(inputRegex)) {
						return item[titleField];
					}
				}), titleField).replace(inputRegex, '');
			}
			return typeahead;
		},

		sources: function() {
			var source = this.get('source');
			return (typeof source === 'string') ? [{href: source}] : source;
		},

		multipleSources: function() {
			return this.get('sources').length > 1;
		},

		options: function() {
			var result = this.get('result'),
				options = [];
			_.each(result, function(group) {
				if (group.options) {
					options = options.concat(group.options);
				}
			});
			return options;
		}
	},

	onrender: function() {

		var promises = [],
			delayedSearch,
			inputElement = this.find('input'),
			acElement = this.find('.autocomplete-suggestive-text'),
			sources = this.get('sources'),
			closeAutoSuggestion = this.get('closeAutoSuggestion');

		// helper function to clear results
		this.clearResults = function () {
			if (closeAutoSuggestion) {
				return this.set('result', []).then(function () {
					this.fire('resultsCleared');
				}.bind(this));	
			} else {
				var deferred = $.Deferred();
				deferred.resolve();
				return deferred.promise();
			}
		}.bind(this);

		// Will work for touch events also.
		$('html').on('click', function(event) {

			if (this.get('options').length === 0) {
				// Not showing the autocomplete UI, ignore.
				return;
			}

			if ($.contains(acElement, event.target)) {
				// Click was inside the ac, ignore.
				return;
			}

			// Clearing the options hides the UI.
			this.clearResults().then(function() {
				if (this.get('allowScrolling')) {
					this.scrollToWidgetTop(inputElement.parentNode, 'fast');
				}
			}.bind(this));

		}.bind(this));

		this.on('newUserInput', function(event) {

			clearTimeout(delayedSearch);

			this.set('userInput', event.node.value);

			if (event.node.value.length < this.get('minChars')) {
				this.clearResults();
				this.set('suggestions', []);
				return;
			}

			// Down, Up, Enter = skip. Every other key (e.g. backspace), allow to trigger.
			// FIXME If using RactiveEventsKeys, why can't I exclude them from keyup? keypress not good enough.
			if (_.includes([40, 38, 13], event.original.which)) {
				return;
			}

			// Add a small delay to avoid making XHR until User's input pauses.
			delayedSearch = setTimeout(function() {

				var userInput = event.node.value;

				// Abort existing request and start a new one.
				_.each(promises, function(promise) {
					promise.abort();
				});

				// reset the pointer for the new search
				this.set('selectedIndex', -1);

				_.each(sources, function(source, index){
					var param = source.queryParameter || this.get('queryParameter'),
						responseType = source.responseType || this.get('responseType');

					promises[index] = $.getJSON(source.href, param + '=' + userInput +
						(responseType === 'jsonp' ? '&callback=?' : ''));

				}.bind(this));

				this.set('ajax', promises);

				$.when.apply($, promises)
					.done(function() {

						var responses = this.get('multipleSources') ? arguments : [arguments],
							result = [],
							optionIndex = 0;

						_.each(responses, function(response, responseIndex) {

							var responseKeyPath = typeof(sources[responseIndex]['responseKeyPath']) === 'undefined'
									? this.get('responseKeyPath') : sources[responseIndex]['responseKeyPath'],
								titleField = typeof(sources[responseIndex]['responseTitleField']) === 'undefined'
									? this.get('responseTitleField') : sources[responseIndex]['responseTitleField'],
								limit = sources[responseIndex]['limit'] || this.get('limit'),
								suggestions;

							suggestions = responseKeyPath ? _.get(response, responseKeyPath) ||
								_.get(response[0], responseKeyPath) : response[0];

							// proceed only if there are valid suggestions
							if (!suggestions || _.isEmpty(suggestions)) {
								return;
							}

							// if limit is defined then show only that number of results
							if (limit > 0) {
								suggestions = suggestions.slice(0, limit);
							}
							this.set('suggestions', suggestions);

							// create another object from suggestions
							// to support the user defined title and url fields
							var userInputRegex = new RegExp('(' + userInput.replace(/\s+/g, '|') + ')', 'gi');
							suggestions = _.map(suggestions, function(item) {

								// highlight the entered value
								var title = item[titleField].replace(userInputRegex,
									function(str) {
										return '<span>' + str + '</span>';
									}
								);

								return {
									'title': title,
									'found': item[titleField],
									'groupIndex': responseIndex,
									'responseObject': item,
									'index': optionIndex++
								};
							});

							result.push({
								groupIndex: responseIndex,
								groupTitle: sources[responseIndex].title || '',
								options: suggestions
							});

						}.bind(this));

						// Always get rid of the zero-eth item "Use entered address: 1 lyon"
						// response.data.suggestions.shift();
						this.set('result', result).then(function() {
							this.fire('onPopulated', result);
							if (this.get('allowScrolling')) {
								this.scrollToWidgetTop(acElement.parentNode, 'fast');
							}
						}.bind(this));

					}.bind(this))
					.fail(function(e){
						if (e.statusText !== 'abort') {
							console.error('uxAutoComplete: Cannot fetch the suggestions due to the following error', e);
						}
						this.set('suggestions', []);
						this.clearResults();
					}.bind(this));

			}.bind(this), this.get('delay'));

		});

		this.on('completeText', function(event) {
			var inputValue         = event.node.value,
				caretPosition      = event.node.selectionStart;

			if (!inputValue) {
				return;
			}

			if (caretPosition >= inputValue.length) {
				if (this.get('typeaheadOption') && this.get('typeahead')) {
					this.set('value', this.get('typeahead'));
				}
			} else if (event.original instanceof KeyboardEvent) {
				event.node.selectionStart = caretPosition + 1;
			}

		}.bind(this));

		this.on('selectOption', function(event) {
			var selectedValue = event.context.found;

			this.clearResults().then(function () {
				this.set({
					// Set the field value.
					value: selectedValue,
					suggestions: []
				}).then(function() {
					if (this.get('allowScrolling')) {
						this.scrollToWidgetTop(inputElement.parentNode, 'fast');
					}

					// fire the select event in the parent event and pass the selected value
					this.fire('onSelect', selectedValue, event.context);
				}.bind(this));
			}.bind(this));



			return false;

		});

		// For keyboard driven UI.
		this.on('selectCurrentOption', function(event) {

			if (this.get('options').length === 0 ||
				this.get('selectedIndex') === -1) {
				this.fire('onEnter', event);
				return false;
			}

			var currentIndex = this.get('selectedIndex'),
				selectedValue = this.get('options')[currentIndex].found,
				selectedOption = this.get('options')[currentIndex];

			this.clearResults().then(function () {
				this.set({
					value: selectedValue,
					suggestions: []
				}).then(function() {
					if (this.get('allowScrolling')) {
						this.scrollToWidgetTop(inputElement.parentNode, 'fast');
					}

					// fire the select event in the parent event and pass the selected value
					this.fire('onSelect', selectedValue, selectedOption);
				}.bind(this));
			}.bind(this));


		});

		this.on('nextOption', function(event) {

			var selectedIndex = this.get('selectedIndex');

			if ((selectedIndex + 1) === this.get('options').length) {
				// Past the post - go no further!
				return;
			}

			this.set('selectedIndex', selectedIndex + 1).then(function() {
				// FIXME Move focus instead (accessibility).
				// var selectedElement = this.find('.selected');
				// this.scrollToWidgetTop(selectedElement, 'fast');
			}.bind(this));

		});

		this.on('prevOption', function(event) {

			var selectedIndex = this.get('selectedIndex');

			if (selectedIndex === 0) {
				// Past the post - go no further!
				return;
			}

			this.set('selectedIndex', selectedIndex - 1).then(function() {
				// FIXME Move focus instead (accessibility).
				// var selectedElement = this.find('.selected');
				// this.scrollToWidgetTop(selectedElement, 'fast');
			}.bind(this));

		});

		this.observe('showSuggestions', function(value) {
			if (!value) {
				this.clearResults();
				var ajaxs = this.get('ajax');
				_.each(ajaxs, function(ajax) {
					if (ajax.abort) {
						ajax.abort();
					}
				});
			}
		}.bind(this));

	}

});
